import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

/** A page title and subtitle, with controls (children) at the right on a wide screen and below on a phone */
export function TitleBar({ title, subtitle, children }: { title: string; subtitle: string; children?: ReactNode }) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={1}
      sx={{ justifyContent: 'space-between', alignItems: { md: 'flex-start' } }}
    >
      <Box>
        <Typography variant="h4" component="h1">
          {title}
        </Typography>
        <Typography color="text.secondary">{subtitle}</Typography>
      </Box>
      {children && (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap', rowGap: 1 }}>
          {children}
        </Stack>
      )}
    </Stack>
  );
}
